import { ActionIcon, Button, Flex, Group, Menu, createStyles } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import swal from "sweetalert";
import FacilityTypeModal from "../../containers/FacilityTypeModal";
import { removeFacilityType } from "../../services/facility";
import { BsThreeDotsVertical } from "react-icons/bs";

const useStyles = createStyles((theme) => ({
  border: {
    borderLeft: "1px solid var(--app-border)"
  },
  bg1: {
    "& td": {
      background: "var(--app-surface)",
    },
    cursor: "pointer",
  },
  bg2: {
    "& td": {
      background: "var(--app-surface-2)",
    },
    cursor: "pointer",
  },
}));
const FacilityTableRow = ({ row, index }) => {
  const [opened, { open, close }] = useDisclosure(false);
  const { classes } = useStyles();
  // functions
  const remove = async (canDelete) => {
    if (canDelete) {
      const willDelete = await swal({
        title: `Are you sure?`,
        text: "This action cannot be undone. Facility Types are further associated to Facilities, Deleting facility type can cause problems.",
        icon: "warning",
        dangerMode: true,
        buttons: ["Cancel", "Delete"]
      });
      if (willDelete) removeFacilityType(row?.id);
    } else {
      swal({
        title: `Not Allowed`,
        text: "You are not allowed to delete this facility.",
        icon: "warning",
        dangerMode: true
      });
    }
  };

  const bg = index % 2 === 0;

  return (
    <tr className={bg ? classes.bg2 : classes.bg1}>
      <td className={classes.border}>
        <Flex
          gap="xs"
          justify="space-between"
          align="center"
          direction="row"
          wrap="wrap"
        >
          {row.type || "-"}
          {/* <Group>
            <FacilityTypeModal
              opened={opened}
              close={close}
              title={"Facility Type"}
              data={row}
            />
            {!row?.general && (
              <ActionIcon color="green" variant="light" onClick={open}>
                <IconEdit />
              </ActionIcon>
            )}
            {!row?.general && (
              <ActionIcon
                color="red"
                variant="light"
                onClick={() => remove(row?.canDelete)}
              >
                <IconTrash />
              </ActionIcon>
            )}
          </Group> */}
        </Flex>
      </td>
      <td className={classes.border} style={{display: 'flex', justifyContent: 'end'}}>
        {!row?.general ? (
          <div style={{ position: "relative", overflow: "visible" }}>
            <FacilityTypeModal
              opened={opened}
              close={close}
              title={"Facility Type"}
              data={row}
            />
            <Menu shadow="md" width={100} withinPortal={true}>
              <Menu.Target>
                <Button variant="unstyled">
                  <BsThreeDotsVertical />
                </Button>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Item onClick={open}>Edit</Menu.Item>
                <Menu.Item onClick={() => remove(row?.canDelete)}>
                  Delete
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </div>
        ) : <div style={{ position: "relative", overflow: "visible" }}>
            <Menu shadow="md" width={100} withinPortal={true}>
              <Menu.Target>
                <Button variant="unstyled" style={{visibility: 'hidden'}}>
                  <BsThreeDotsVertical />
                </Button>
              </Menu.Target>
            </Menu>
          </div>}
      </td>
    </tr>
  );
};

export default FacilityTableRow;
